import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ColorIconFocused',
  props: {
    fill: {
      type: String,
      default: '#363636',
    },
  },
  setup(__props) {

  

return { __sfc: true, }
}

})